class SearchBox {
  constructor(element) {
    this.element = element;
    this.trigger = this.element.getElementsByClassName('c-searchbox__trigger')[0] || undefined;
    this.actor = this.element.getElementsByClassName('c-searchbox__actor')[0] || undefined;
    this.searchfield = this.actor.getElementsByClassName('o-form__input--search')[0] || undefined;

    if (this.trigger && this.actor && this.searchfield) {
      this._addEventListeners();
    }
  }

  /**
   * Adds handlers to scroll and resizing events to update sticky class and to
   * resize the topBarHelper
   *
   * @todo Check if we can add EventListeners once and extend handlers via API.
   *
   * @private
   */
  _addEventListeners() {
    this.trigger.addEventListener('click', () => {
      this.searchfield.focus();
    });
  }
}

export default SearchBox;
